// the version listed here will be used to create the link to the eula PDF
// as well as in the backend request to the registration service
export const CURRENT_EULA_VERSION = '1.0.2';
